export default __webpack_public_path__ + "static/media/ep5collage5.cfbfcd31.jpg";